import DefaultBuilding from '@assets/img/EDGE/default-building.svg';
import Error404 from '@assets/img/EDGE/error-404.svg';
import Error500 from '@assets/img/EDGE/error-500.svg';
import Isotipo from '@assets/img/EDGE/isotipo.svg';
import LogoImage from '@assets/img/EDGE/logo.svg';
import NoBuildings from '@assets/img/EDGE/no-buildings.svg';
import NoFloorplans from '@assets/img/EDGE/no-floorplans.svg';

import { ImageType } from './load-images.model';

const EDGEImages = {
  DefaultBuilding: DefaultBuilding,
  Error404: Error404,
  Error500: Error500,
  Isotipo: Isotipo,
  Logo: LogoImage,
  NoBuildings: NoBuildings,
  NoFloorplans: NoFloorplans
} as ImageType;

export { EDGEImages };
